import { InjectionToken } from "@angular/core";
import { IAppRouterService } from "../interfaces/app-router-service";
import { APP_FEATURE_GROUP_ID } from "./app-constants";
import { RouteNavCommandData } from "../models/route-nav-command";
import { ICommonConfig } from "../interfaces/common-config";
import { IAppService } from "../interfaces/app-service";

/**
 * A generic injection token used for the AppRouter service
 * Most commonly used in common-ng components and services
 */
export const APP_ROUTER_SERVICE = new InjectionToken<IAppRouterService>(APP_FEATURE_GROUP_ID);

/**
 * An injection token used for the Root route in the Application
 */
export const APP_ROOT_NAV_COMMAND_DATA = new InjectionToken<RouteNavCommandData>("APP_ROOT_NAV_COMMAND_DATA");

/**
 * An injection token used for the Error route in the Application
 */
export const APP_ERROR_NAV_COMMAND_DATA = new InjectionToken<RouteNavCommandData>("APP_ERROR_NAV_COMMAND_DATA");

/**
 * Used to inject the LOGOUT NAV COMMAND DATA to be used in the Error handler when there's a token error.
 *
 * This is an optional dependency
 */
export const APP_LOGOUT_NAV_COMMAND_DATA = new InjectionToken<RouteNavCommandData>("APP_LOGOUT_NAV_COMMAND_DATA");

/**
 * This is the token for the ICommonConfig
 *
 * It is used internally for the library
 *
 * It is included in the public library for testing purposes. Applications should use there own APP_CONFIG token
 *
 */
export const COMMON_APP_CONFIG = new InjectionToken<ICommonConfig>("COMMON_APP_CONFIG");

/**
 * This is the token used for IAppService.
 *
 * It is used internally for the CommonNgLibrary.
 *
 */
export const COMMON_APP_SERVICE = new InjectionToken<IAppService>("COMMON_APP_SERVICE");
